import guid from '@/lib/guid';
import ApiService from '@/services/api.service';
const table = 'projects';
const schema = {projects: "id, name, description"};
import {db} from '@/services/db.js';
import ParameterisedChart from "./parametised-chart"




export class Project {
  constructor({ id = null, name = ``, description = ``} = {}) {
    //
    this.id = id;
    if(!this.id) {
      this.id = guid.createId('project');
    }
    this.name = name;
    this.description = description;
  }
}


export class Application extends ParameterisedChart {
  constructor({ id = null, name = ``, description = ``, properties = {}} = {}) {
    //
    this.id = id;
    if(!this.id) {
      this.id = guid.createId('project');
    }
    this.type = "application";
    this.name = name;
    this.description = description;
    this.setPropertiesUsingString(properties);
    this.setParameters();
    // this.loading = false;
  }

  setPropertiesUsingString(properties) {
    try {
      this.properties = JSON.parse(properties);
      this.schema = this.properties.schema;
      this.boards = this.properties.boards;
      this.dataSources = this.properties.dataSources;
    } catch(error) {
      this.reset();
    }
  }

  getProperties() {
    this.properties.schema = this.schema;
    this.properties.boards = this.boards;
    this.properties.dataSources = this.dataSources;
  }

  reset() {
    this.properties = {};
    this.parameters = {};
    this.boards = [];
    this.dataSources = [];
  }

  setBoards(boards) {
    this.boards = boards;
  }

  setDataSources(dataSources) {
    this.dataSources = dataSources;
  }

  getProperties() {

  }
}




function hydrateDb(project) {
  return {
    id: project.id,
    name: project.name,
    description: project.descrpition
  }
}


function hydrateNative(project) {
  return new Project(project);
}

export function createProject() {
  return new Project();
}

export async function getProjects(params) {
  try {
    const response = await ApiService.query('/project/search/findByUserId', {params: params});
    const result = hydrateApiProjects(response.data);
    return result;
    // return hydrateProjects(await db[table].toArray());
  } catch (err) {
    return [];
  }
}

export function hydrateApiProjects(response) {
  const projects = response;
  const result = [];
  projects.forEach(function(project) {
    result.push(new Project(project))
  });
  return result;
}

export function hydrateProjects(projects) {
  let result = [];
  projects.forEach(function(project) {
    result.push(new Project(project))
  });
  return result;
}

export async function deleteProject(id) {
  return await ApiService.delete('/project/' + id);
}

export async function addProject(project) {
  const response = await ApiService.post('/project', project);
  // console.log("response", response);
  return new Project(response.data);
  // return getProjects({userId: project.userId});
  // return db[table].put(hydrateDb(project))
}



export async function updateProject(project) {

  // return db[table].update(project.id, hydrateDb(project))
}

export async function updateProperties(application) {
  const response = await ApiService.post('/project/update/properties/' + application.id, {properties: application.getProperties()});
  // return db[table].update(project.id, hydrateDb(project))
}